<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <div class="container start-page">
      @if (!hideTopQuestions) {
      <div class="nh-table-mobile d-lg-none">
        <h1 class="section-header">
          {{ "APPEAL_REP_DETAILS_MOBILE_STATIC1" | globalTranslate }}
        </h1>
        <hr />
      </div>
      } @if (!hideTopQuestions) {
      <div class="d-none d-lg-block">
        <h1 class="section-header">
          {{ "APPEAL_REP_DETAILS_DESKTOP_STATIC1" | globalTranslate }}
        </h1>
        <hr />
      </div>
      } @if (authRepresntativeObj?.eligRepresentativeName && !hideTopQuestions)
      {
      <div>
        <p>{{ "APPEAL_REP_DETAILS_STATIC2" | globalTranslate }}</p>
        @for (choice of individualTable; track choice; let i = $index) {
        <div class="mt-2 pt-2">
          <div class="form-check pb-md-1 checkbox">
            <label class="form-check-label mt-2">
              <input
                type="checkbox"
                class="form-check-input"
                [value]="choice.eligAuthSelected"
                aria-label="individualTable{i}"
                (change)="selectCheckBox($event)"
                [checked]="choice.eligAuthSelected"
              />
              {{ choice.name }} - {{ choice.relation }}
            </label>
          </div>
        </div>
        }
        <br />
      </div>
      } @if ((eligAuthResprentativeSw === 'N' || !eligAuthResprentativeSw) &&
      !hideTopQuestions) {
      <p>{{ "APPEAL_REP_DETAILS_STATIC4" | globalTranslate }}</p>
      }
      <h2 class="section-header">
        {{ "APPEAL_REP_DETAILS_STATIC5" | globalTranslate }}
      </h2>
      <hr />
      @if (!authEligibleExists && !hideTopQuestions) {
      <nh-field
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'APPEAL_REP_DETAILS_STATIC6' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="addReprentative"
          [items]="tableCodeValue('YESNO', 'data.addReprentative')"
          [attr.aria-label]="'APPEAL_REP_DETAILS_STATIC6' | globalTranslate"
          (change)="addReprentative()"
          formControlName="addReprentative"
        ></select>
      </nh-field>
      } @if (authEligibleExists && !hideTopQuestions) {
      <nh-field
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'APPEAL_REP_DETAILS_STATIC7' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="addReprentative"
          [items]="tableCodeValue('YESNO', 'data.addReprentative')"
          [attr.aria-label]="'APPEAL_REP_DETAILS_STATIC7' | globalTranslate"
          (change)="addReprentative()"
          formControlName="addReprentative"
        ></select>
      </nh-field>
      } @if ((isY('data.addReprentative'))) {
      <div>
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REP_DETAILS_STATIC8' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="appeallantRelationship"
            [items]="
              tableCodeValue('APRELATIONSHIP', 'data.appeallantRelationship')
            "
            [attr.aria-label]="'APPEAL_REP_DETAILS_STATIC8' | globalTranslate"
            (change)="onRelationChange()"
            formControlName="appeallantRelationship"
          ></select>
        </nh-field>
      </div>
      }
      <nh-alert type="danger" [isOpen]="showRelationValidation">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>{{
              "APPEAL_RELATION_VALIDATION_MESSAGE_5_R" | globalTranslate
            }}</span>
          </div>
        </div>
      </nh-alert>
      <nh-alert type="warning" [isOpen]="showDuplicateValidation">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt="warning"
            />
          </div>
          <div class="col message">
            <span>{{
              "APPEAL_DUPLICATE_VALIDATION_MESSAGE" | globalTranslate
            }}</span>
          </div>
        </div>
      </nh-alert>
      @if (relationshipSelected) {
      <div>
        <nh-name-address
          [nameMandatory]="nameFieldsMandatory"
          (change)="onRepresentativeChange()"
          [namePopup]="true"
          [personalName]="getControl('data.name')"
          [isAssistingPerson]="false"
          [tables]="tables"
        >
        </nh-name-address>
        <nh-field
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'GENDER' | globalTranslate }}"
          class="label-section"
        >
          <select
            [attr.aria-label]="'GENDER' | globalTranslate"
            nhTranslate
            name="gender"
            formControlName="gender"
            [items]="tableCodeValue('GENDER', 'data.gender')"
          ></select>
        </nh-field>
        <nh-field
          name="organizationName"
          [mandatory]="organizationMadatory"
          [attr.aria-required]="organizationMadatory"
          label="{{ 'APPEAL_REP_DETAILS_STATIC9' | globalTranslate }}"
          class="label-section"
        >
          <input
            (input)="onInput($event)"
            type="text"
            name="organizationName"
            class="form-control"
            [attr.aria-label]="'APPEAL_REP_DETAILS_STATIC9' | globalTranslate"
            formControlName="organizationName"
            maxlength="45"
          />
        </nh-field>
        <div [formGroup]="getControl('data.representativeAddress')">
          <nh-field
            name="addressFormat"
            label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
            class="label-section"
          >
            <nh-popover
              class="ps-1"
              content="{{ 'CASE_HEAD_POPOVER_TEXT' | globalTranslate }}"
            ></nh-popover>
            <select
              nhTranslate
              name="addressFormat"
              [items]="
                tableCodeValue(
                  'ADDRESSFORMATTYPES',
                  'data.representativeAddress.addressFormat'
                )
              "
              [attr.aria-label]="'ADDRESS_FORMAT' | globalTranslate"
              formControlName="addressFormat"
              (change)="addressFormat()"
            ></select>
          </nh-field>
          <nh-name-address
            (change)="onRepresentativeChange()"
            [addressname]="'appeal-representative'"
            [addressFormat]="
              getControl('data.representativeAddress.addressFormat')
            "
            [address]="getControl('data.representativeAddress.address')"
            [stateDefault]="false"
            [isAssistingPerson]="false"
            [tables]="tables"
          >
          </nh-name-address>
        </div>
        <div [formGroup]="getControl('data.contactDetails')">
          <nh-field
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'CELL_PHONE' | globalTranslate }}"
          >
            <input
              type="text"
              name="cell"
              formControlName="cell"
              class="form-control"
              mask="000-000-0000"
              [attr.aria-label]="'CELL_PHONE' | globalTranslate"
              placeholder="XXX-XXX-XXXX"
            />
          </nh-field>
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="{{ 'WORK_PHONE' | globalTranslate }}"
          >
            <input
              type="text"
              name="work"
              formControlName="work"
              class="form-control"
              mask="000-000-0000"
              [attr.aria-label]="'WORK_PHONE' | globalTranslate"
              placeholder="XXX-XXX-XXXX"
            />
          </nh-field>
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="{{ 'FAX' | globalTranslate }}"
          >
            <input
              type="text"
              name="fax"
              formControlName="fax"
              class="form-control"
              mask="000-000-0000"
              [attr.aria-label]="'FAX' | globalTranslate"
              placeholder="XXX-XXX-XXXX"
            />
          </nh-field>
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="{{ 'APPEAL_EMAIL' | globalTranslate }}"
            class="label-section"
          >
            <input
              type="email"
              name="email"
              class="form-control"
              aria-label="email"
              formControlName="email"
              [attr.aria-label]="'APPEAL_EMAIL' | globalTranslate"
              maxlength="63"
            />
          </nh-field>
        </div>
        <br />
        <button
          id="reset"
          (click)="resetAll()"
          class="btn btn-secondary btn-search"
        >
          {{ "RESET" | globalTranslate }}
        </button>
      </div>
      }
    </div>
  </section>
</nh-form>